export default (vNode) => typeof vNode.componentInstance !== 'undefined' && vNode.componentInstance.$isServer;
